/**
 * 基础路由
 * @type { *[] }
 */
/**
 * page
 */
import PageIndex from "@/views/page/Index";
import PageCourse from "@/views/page/Course";
import PageCommon from '@/views/page/Common';
import PageInfo from '@/views/page/Info';
import PageUser from '@/views/page/User'
import PageTeacher from '@/views/page/Teacher';
import CourseDetails from '@/views/page/CourseDetails';
import TeacherDetails from '@/views/page/TeacherDetails';
import InfoDetails from '@/views/page/InfoDetails';
import LiveRoom from '@/views/page/LiveRoom';
import CallUs from '@/views/page/CallUs';
import CompanyBrief from '@views/page/CompanyBrief'
import Question from '@/views/page/Question';
import Quiz from '@/views/page/Quiz';
import Report from '@/views/page/Report'
import Agreement from '@/views/page/userAgreement';
import StudentWish from '@views/page/StudentWish'
import Download from '@views/page/Download';
import Privacy from '@views/page/PrivacyPolicy'

export const constantRouterMap = [{
        path: '/',
        redirect: '/page/index',
        beforeEnter: (to, from, next) => {
            to()
          }
    },
    {
        path: '/page',
        name: 'page',
        component: PageCommon,
        meta: {
            title: '首页'
        },
        children: [{
                path: 'index',
                name: 'index',
                component: PageIndex,
                meta: {
                    title: '首页'
                }
            },
            {
                path: 'course',
                name: 'course',
                component: PageCourse,
                meta: {
                    title: '精品课程'
                }
            },
            {
                path: 'live_room',
                name: 'live_room',
                component: LiveRoom,
                meta: {
                    title: '直播间'
                }
            },
            {
                path: 'question/quiz',
                name: 'quiz',
                component: Quiz,
                meta: {
                    title: '答题页'
                }
            },
            {
                path: 'info',
                name: 'info',
                component: PageInfo,
                meta: {
                    title: '课堂资讯'
                }
            },
            {
                path: 'teacher',
                name: 'teacher',
                component: PageTeacher,
                meta: {
                    title: '精英名师'
                }
            },
            {
                path: 'teacher_details',
                name: 'teacher_details',
                component: TeacherDetails,
                meta: {
                    title: '名师详情'
                }
            }, {
                path: 'question',
                name: 'question',
                component: Question,
                meta: {
                    title: '题库练习'
                }
            },
            {
                path: 'question/report',
                name: 'report',
                component: Report,
                meta: {
                    title: '答题报告'
                }
            },
            {
                path: 'info_details',
                name: 'info_details',
                component: InfoDetails,
                meta: {
                    title: '资讯详情'
                }
            },
            {
                path: 'course_details',
                name: 'course_details',
                component: CourseDetails,
                meta: {
                    title: '课程详情'
                }
            },
            {
                path: 'user',
                name: 'user',
                component: PageUser,
                meta: {
                    title: '用户首页'
                }
            }, {
                path: 'call_us',
                name: 'call_us',
                component: CallUs,
                meta: {
                    title: '关于我们'
                }
            }, {
                path: 'company_brief',
                name: 'company_brief',
                component: CompanyBrief,
                meta: {
                    title: '公司简介'
                }
            },
            {
                path: 'agreement',
                name: 'agreement',
                component: Agreement,
                meta: {
                    hiddenHeaderContent: true,
                    title: '用户协议'
                }
            },
            {
                path: 'studentWish',
                name: 'studentWish',
                component: StudentWish,
                meta: {
                    title: '学员心声'
                }
            },
            {
                path: 'download',
                name: 'download',
                component: Download,
                meta: {
                    title: '下载中心'
                }
            },
            {
                path: 'privacy_policy',
                name: 'privacy_policy',
                component: Privacy,
                meta: {
                    title: '隐私政策'
                }
            }
        ]
    },
    
    {
        path: '/404',
        component: () =>
            import( /* webpackChunkName: "fail" */ '@/views/exception/404')
    },
]